import { headerAuth } from "../standardAuthPatterns";
import { defineConnector } from "../types";
import logo from "./logo.svg";

export const ionos = defineConnector({
  identifier: "ionos",
  name: "IONOS",
  tagLine: "Cloud infrastructure and hosting",
  logo,
  protocol: "http",
  tags: ["it"],
  defaultUrlPattern: () => "https://api\\.ionos\\.com/.*",
  auth: (app) =>
    headerAuth([
      {
        name: "Authorization",
        value: app.secret.apiKey,
        scheme: "Basic",
      },
    ]),
  steps: [
    {
      title: "Get your IONOS API token",
      items: [
        {
          kind: "markdown",
          content:
            "Go to the [IONOS Developer Portal](https://developer.hosting.ionos.com/) and generate an API token from the **API Keys** section.",
        },
        {
          kind: "input",
          label: "API token",
          required: true,
          target: { kind: "secrets", field: "apiKey" },
          helperText: "The Base64-encoded contract:token value.",
        },
      ],
    },
  ],
  connectionTest: {
    protocol: "http",
    request: () => "https://api.ionos.com/cloudapi/v6/datacenters",
  },
});
